import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
    exportBpfSousMenuItem,
    financierSousMenuItem,
    participantSousMenuItem,
    formateurSousMenuItem,
    qualitySousMenuItem,
    sessionSousMenuItem,
    commercialSousMenuItem
} from './sous-menu-items.constantes';

export const statistiquesMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-stats-up', 'Statistiques', [
    exportBpfSousMenuItem,
    financierSousMenuItem,
    participantSousMenuItem,
    formateurSousMenuItem,
    qualitySousMenuItem,
    sessionSousMenuItem,
    commercialSousMenuItem,
]);
